import { Drawer as BaseDrawer } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const Drawer = styled(BaseDrawer)`
  position: relative;

  .ant-drawer-header {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
`;

export const LeftPanel = styled.div`
  padding: 70px 15px 20px 20px;
  width: 300px;
  flex: 0;
`;

export const RightPanel = styled.div`
  position: relative;
  background-color: #fff;
  padding: 0 20px 20px 20px;
  flex: 1;
  width: calc(100% - 300px);
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const CloseIcon = styled(CloseOutlined)`
  position: absolute;
  top: 29px;
  right: 15px;
  z-index: 999;
`;

export const LoadingMask = styled.div`
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  background: rgba(0, 0, 0, 0.05);
`;